import { get, uniqBy } from 'lodash'
import randomcolor from 'randomcolor'
import moment from 'moment'
import { PERIOD_CHOICES } from '@batimentb/vadimm-js-commons/values'
import { mapGetters } from 'vuex'
import { DefaultValues } from '@/mixins'

export default {
  name: 'StatsMixins',
  mixins: [DefaultValues],
  data () {
    return {
      isParent: false,
      loading: false,
      statsSalesPreReservation: [],
      statsSalesReservation: [],
      statsSalesSold: [],
      statsSalesCanceled: [],
      statsReferenceSalesPreReservation: [],
      statsReferenceSalesReservation: [],
      statsReferenceSalesSold: [],
      statsRdvs: [],
      flowRate: 0,
      statsMultidiffusion: [],
      statOpenedEntity: null,
      sortKey: null,
      sortOrder: null,
      hasSort: false,
      sortBy: {},
      periodSelected: null,
      referenceSelected: {
        start: null,
        end: null
      },
      filters: {
        status: ['pre_reserved', 'reserved', 'sold', 'canceled']
      }
    }
  },
  props: {
    sourceStatsSalesPreReservation: {
      type: Array,
      default: () => []
    },
    sourceStatsSalesReservation: {
      type: Array,
      default: () => []
    },
    sourceStatsSalesSold: {
      type: Array,
      default: () => []
    },
    sourceStatsSalesCanceled: {
      type: Array,
      default: () => []
    },
    sourceStatsReferenceSalesPreReservation: {
      type: Array,
      default: () => []
    },
    sourceStatsReferenceSalesReservation: {
      type: Array,
      default: () => []
    },
    sourceStatsReferenceSalesSold: {
      type: Array,
      default: () => []
    },
    sourceStatsRdvs: {
      type: Array,
      default: () => []
    },
    sourceStatsMultidiffusion: {
      type: Array,
      default: () => []
    },
    sourceLoading: {
      type: Boolean,
      default: false
    },
    sourceFlowRate: {
      type: Number,
      default: 0
    },
    sourceSortedParams: Object
  },
  computed: {
    ...mapGetters(['accountPk']),
    statsDefaultParams () {
      // need to be defined with proper key
      return {}
    },
    sortedParams () {
      return {
        sortKey: this.sortKey,
        sortOrder: this.sortOrder,
        hasSort: this.hasSort,
        sortBy: this.sortBy
      }
    },
    periodsDatas () {
      let q1 = moment().quarters(1)
      let q2 = moment().quarters(2)
      let q3 = moment().quarters(3)
      let q4 = moment().quarters(4)
      let periods = [
        {
          value: 'semaine',
          start: moment().startOf('week').toDate(),
          end: moment().endOf('week').toDate()
        },
        {
          value: 'mois',
          start: moment().startOf('month').toDate(),
          end: moment().endOf('month').toDate()
        },
        {
          value: 'trenteJours',
          start: moment().subtract(30, 'days').startOf('day').toDate(),
          end: moment().endOf('day').toDate()
        },
        {
          value: 'trimUn',
          start: q1.startOf('quarter').toDate(),
          end: q1.endOf('quarter').toDate()
        },
        {
          value: 'trimDeux',
          start: q2.startOf('quarter').toDate(),
          end: q2.endOf('quarter').toDate()
        },
        {
          value: 'trimTrois',
          start: q3.startOf('quarter').toDate(),
          end: q3.endOf('quarter').toDate()
        },
        {
          value: 'trimQuatre',
          start: q4.startOf('quarter').toDate(),
          end: q4.endOf('quarter').toDate()
        }
      ]
      return Object.values(PERIOD_CHOICES).map(x => {
        return { ...x, ...periods.find(y => y.value === x.value) }
      })
    },
    referenceDatas () {
      let diff = moment(this.rawEndDate).diff(this.rawStartDate, 'days')
      return [
        {
          label: 'Période précédente',
          value: 'lastPeriod',
          start: moment(this.rawStartDate).subtract(diff, 'days').toDate(),
          end: moment(this.rawStartDate).subtract(1, 'day').toDate()
        },
        {
          label: 'Année précédente',
          value: 'lastYear',
          start: moment(this.rawStartDate).subtract(1, 'year').toDate(),
          end: moment(this.rawEndDate).subtract(1, 'year').toDate()
        }
      ]
    },
    allPeriod () {
      let data = {}
      let dates = []
      let startDate = this.rawStartDate
      let endDate = this.rawEndDate
      while (moment(startDate).isBefore(endDate)) {
        dates.push(moment(startDate).format('YYYY-MM'))
        startDate = moment(startDate).add(1, 'month')
      }
      dates.forEach(date => {
        data[date] = {
          date: moment(date).format('YYYY-MM'),
          rdvs: [],
          sales: []
        }
      })
      return data
    },
    sortedSales () {
      let items = []
      if (this.$route.name === 'StatsSellers') items = [...this.statsSales]
      else if (this.$route.name === 'StatsSales' || this.$route.name === 'StatsProgramSales') items = [...this.statsSales]
      else if (this.$route.name === 'StatsRdvs') items = [...this.statsRdvs]
      if (this.hasSort) {
        return items.sort((a, b) => {
          if (!a[this.sortKey]) a[this.sortKey] = 0
          if (!b[this.sortKey]) b[this.sortKey] = 0
          if (this.sortOrder === 'asc') {
            if (typeof a[this.sortKey] === 'number') return a[this.sortKey] - b[this.sortKey]
            else if (a[this.sortKey] && b[this.sortKey]) {
              let sortA = a[this.sortKey].trim()
              let sortB = b[this.sortKey].trim()
              if (sortA.toLowerCase() < sortB.toLowerCase()) return -1
              else if (sortA.toLowerCase() > sortB.toLowerCase()) return 1
              else return 0
            }
          } else {
            if (typeof a[this.sortKey] === 'number') return b[this.sortKey] - a[this.sortKey]
            else if (a[this.sortKey] && b[this.sortKey]) {
              let sortA = a[this.sortKey].trim()
              let sortB = b[this.sortKey].trim()
              if (sortA.toLowerCase() < sortB.toLowerCase()) return 1
              else if (sortA.toLowerCase() > sortB.toLowerCase()) return -1
              else return 0
            }
          }
        })
      } else return items
    },
    statsSales () {
      return uniqBy([...this.statsSalesPreReservation, ...this.statsSalesReservation, ...this.statsSalesSold, ...this.statsSalesCanceled], 'pk')
    },
    statsReferenceSales () {
      return uniqBy([...this.statsReferenceSalesPreReservation, ...this.statsReferenceSalesReservation, ...this.statsReferenceSalesSold], 'pk')
    },
    validStatsSales () {
      return uniqBy([...this.statsSalesReservation, ...this.statsSalesSold], 'pk')
    },
    validStatsReferenceSales () {
      return uniqBy([...this.statsReferenceSalesReservation, ...this.statsReferenceSalesSold], 'pk')
    },
    totalSales () {
      if (!this.statsSales || !this.statsSales.length) return {}
      return this.processTotalSales(this.statsSales)
    },
    totalReferenceSales () {
      if (!this.statsReferenceSales || !this.statsReferenceSales.length) return {}
      return this.processTotalSales(this.statsReferenceSales)
    },
    pastRdvsWithoutR0 () {
      return this.statsRdvs.filter(x => moment(x.date).format('x') < moment().format('x') && x.rdv_type !== 'R0').length
    }
  },
  watch: {
    sourceSortedParams (v) {
      this.sortKey = v.sortKey
      this.sortOrder = v.sortOrder
      this.hasSort = v.hasSort
      this.sortBy = v.sortBy
    },
    // watch every props sources to update stats values
    sourceStatsSalesPreReservation (v) { this.updateSources({ salesPreReservation: v }) },
    sourceStatsSalesReservation (v) { this.updateSources({ salesReservation: v }) },
    sourceStatsSalesSold (v) { this.updateSources({ salesSold: v }) },
    sourceStatsSalesCanceled (v) { this.updateSources({ salesCanceled: v }) },
    sourceStatsReferenceSalesPreReservation (v) { this.updateSources({ referenceSalesPreReservation: v }) },
    sourceStatsReferenceSalesReservation (v) { this.updateSources({ referenceSalesReservation: v }) },
    sourceStatsReferenceSalesSold (v) { this.updateSources({ referenceSalesSold: v }) },
    sourceStatsRdvs (v) { this.updateSources({ rdvs: v }) },
    sourceStatsMultidiffusion (v) { this.updateSources({ multidiffusion: v }) },
    sourceFlowRate (v) { this.updateSources({ flowRate: v }) }
  },
  created () {
    this.updateDateFilter({ start: this.rawStartDate, end: this.rawEndDate })
  },
  mounted () {
    this.updateSources({
      salesPreReservation: this.sourceStatsSalesPreReservation,
      salesReservation: this.sourceStatsSalesReservation,
      salesSold: this.sourceStatsSalesSold,
      salesCanceled: this.sourceStatsSalesCanceled,
      referenceSalesPreReservation: this.sourceStatsReferenceSalesPreReservation,
      referenceSalesReservation: this.sourceStatsReferenceSalesReservation,
      referenceSalesSold: this.sourceStatsReferenceSalesSold,
      rdvs: this.sourceStatsRdvs,
      multidiffusion: this.sourceStatsMultidiffusion,
      flowRate: this.sourceFlowRate
    })
  },
  methods: {
    // Need to be define in main vue
    getStats () {
      return undefined
    },
    async updateDateFilter (period) {
      if (period) {
        if (period.start) this.$set(this, 'rawStartDate', period.start)
        if (period.end) this.$set(this, 'rawEndDate', period.end)
      } else {
        this.rawStartDate = moment().startOf('year').toDate()
        this.rawEndDate = moment().endOf('day').toDate()
      }
      if (this.rawEndDate && this.rawStartDate && moment(this.rawEndDate).isBefore(this.rawStartDate)) {
        this.$set(this, 'rawStartDate', moment(this.rawEndDate).toDate())
      }
      if (this.rawStartDate) {
        this.filters.date__gte = moment(this.rawStartDate).startOf('day').toISOString()
      }
      if (this.rawEndDate) {
        this.filters.date__lte = moment(this.rawEndDate).endOf('day').toISOString()
      }
      await this.getStats()
      this.$nextTick(() => {
        if (this.referenceSelected) {
          this.referenceSelected = this.referenceDatas.find(x => x.value === this.referenceSelected.value)
          if (this.referenceSelected) {
            setTimeout(async () => {
              await this.getStats(true)
            }, 500)
          }
        }
      })
    },
    async getStatsSales (referenceMode) {
      this.loading = true
      await Promise.all([
        this.getStatsSalesPreReservation(referenceMode),
        this.getStatsSalesReservation(referenceMode),
        this.getStatsSalesSold(referenceMode)
      ])
      this.loading = false
    },
    async getStatsSalesPreReservation (referenceMode) {
      if (this.filters.status && this.filters.status.length && (!this.filters.status.includes('pre_reserved') && !this.filters.status.includes('canceled'))) {
        this.updateSources({ salesPreReservation: [] })
        this.updateSources({ salesCanceled: [] })
        return
      }
      let params = {
        ...this.statsDefaultParams,
        status: [],
        pre_reservation_date__gte: this.filters.date__gte,
        pre_reservation_date__lte: this.filters.date__lte
      }
      if (this.filters.status && this.filters.status.length && this.filters.status.includes('pre_reserved')) params.status.push('pre_reserved')
      if (this.filters.status && this.filters.status.length && this.filters.status.includes('canceled')) params.status.push('canceled')
      if (referenceMode) {
        params.pre_reservation_date__gte = this.referenceSelected.start
        params.pre_reservation_date__lte = this.referenceSelected.end
      }
      try {
        const { data } = await this.$statsApi.get(`/${this.accountPk}/sales`, { params })
        if (referenceMode) {
          this.updateSources({ referenceSalesPreReservation: this.computeSalesData(data) })
        } else {
          this.updateSources({ salesPreReservation: this.computeSalesData(data.filter(x => x.status === 'pre_reserved')) })
          this.updateSources({ salesCanceled: this.computeSalesData(data.filter(x => x.status === 'canceled')) })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getStatsSalesReservation (referenceMode) {
      if (this.filters.status && this.filters.status.length && (!this.filters.status.includes('reserved'))) {
        this.updateSources({ salesReservation: [] })
        return
      }
      let params = {
        ...this.statsDefaultParams,
        status: [],
        signature_date__gte: this.filters.date__gte,
        signature_date__lte: this.filters.date__lte
      }
      if (this.filters.status && this.filters.status.length && this.filters.status.includes('reserved')) params.status.push('reserved')
      if (referenceMode) {
        params.signature_date__gte = this.referenceSelected.start
        params.signature_date__lte = this.referenceSelected.end
      }
      try {
        const { data } = await this.$statsApi.get(`/${this.accountPk}/sales`, { params })
        if (referenceMode) {
          this.updateSources({ referenceSalesReservation: this.computeSalesData(data) })
        } else {
          this.updateSources({ salesReservation: this.computeSalesData(data) })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getStatsSalesSold (referenceMode) {
      if (this.filters.status && this.filters.status.length && (!this.filters.status.includes('sold'))) {
        this.updateSources({ salesSold: [] })
        return
      }
      let params = {
        ...this.statsDefaultParams,
        status: [],
        sale_date__gte: this.filters.date__gte,
        sale_date__lte: this.filters.date__lte
      }
      if (this.filters.status && this.filters.status.length && this.filters.status.includes('sold')) params.status.push('sold')
      if (referenceMode) {
        params.sale_date__gte = this.referenceSelected.start
        params.sale_date__lte = this.referenceSelected.end
      }
      try {
        const { data } = await this.$statsApi.get(`/${this.accountPk}/sales`, { params })
        if (referenceMode) {
          this.updateSources({ referenceSalesSold: this.computeSalesData(data) })
        } else {
          this.updateSources({ salesSold: this.computeSalesData(data) })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getStatsRdvs () {
      this.loading = true
      let params = {
        ...this.statsDefaultParams,
        date__gte: this.filters.date__gte,
        date__lte: this.filters.date__lte
      }
      try {
        const { data } = await this.$statsApi.get(`/${this.accountPk}/rdvs`, { params })
        this.updateSources({ rdvs: this.computeRdvsData(data) })
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    async getFlowRate () {
      let stockParams = {
        ...this.statsDefaultParams,
        lot__status: ['available', 'optioned', 'pre_reserved', 'reserved', 'sold'],
        program__status: ['available', 'archived'],
        nature: Object.keys(this.naturesData).filter(x => x !== 'parking'),
        per_page: 1,
        cached: 1
      }
      let stock = await this.$api.get(this.$resources.STOCK_LOT, stockParams)
      let lotCount = stock.data.count
      let statsParams = {
        ...this.statsDefaultParams,
        status: ['reserved', 'sold']
      }
      let stats = await this.$statsApi.get(`/${this.accountPk}/sales`, { params: statsParams })
      let allStats = stats.data
      let flowRate = allStats.filter(x => x.lot.nature !== 'parking').length / lotCount * 100
      this.updateSources({ flowRate })
    },
    updateFilters (filters) {
      this.filters = filters
      this.getStats()
    },
    updateReference (referenceSelected) {
      if (referenceSelected) {
        this.referenceSelected = referenceSelected
        this.getStatsSales(true)
      }
    },
    updateStats () {
      this.$emit('updateStats')
    },
    updateSources ({
      salesPreReservation = null,
      salesReservation = null,
      salesSold = null,
      salesCanceled = null,
      rdvs = null,
      multidiffusion = null,
      referenceSalesPreReservation = null,
      referenceSalesReservation = null,
      referenceSalesSold = null,
      flowRate = null
    }) {
      if (salesPreReservation !== null) this.statsSalesPreReservation = salesPreReservation
      if (salesReservation !== null) this.statsSalesReservation = salesReservation
      if (salesSold !== null) this.statsSalesSold = salesSold
      if (salesCanceled !== null) this.statsSalesCanceled = salesCanceled
      if (rdvs !== null) this.statsRdvs = rdvs
      if (referenceSalesPreReservation !== null) this.statsReferenceSalesPreReservation = referenceSalesPreReservation
      if (referenceSalesReservation !== null) this.statsReferenceSalesReservation = referenceSalesReservation
      if (referenceSalesSold !== null) this.statsReferenceSalesSold = referenceSalesSold
      if (multidiffusion !== null) this.statsMultidiffusion = multidiffusion
      if (flowRate !== null) this.flowRate = flowRate
    },
    sort (by, e) {
      for (const s in this.sortBy) {
        this.$set(this.sortBy, s, { order: null, sort: false })
      }
      this.sortOrder = e.order
      this.sortKey = by
      this.hasSort = e.sort
      this.$set(this.sortBy, by, e)
    },
    computeSalesData (sales) {
      return sales.map(sale => {
        return {
          ...sale,
          user_name: sale.user ? `${sale.user.last_name} ${sale.user.first_name}` : '',
          user_pk: sale.user ? sale.user.pk : null,
          account_name: sale.account ? sale.account.name : '',
          account_pk: sale.account ? sale.account.pk : null,
          program_name: sale.program ? sale.program.name : '',
          lot_ref: sale.lot ? sale.lot.ref : '',
          contact_name: sale.contact ? `${sale.contact.last_name} ${sale.contact.first_name}` : '',
          contact_pk: sale.contact ? sale.contact.pk : null,
          origin_name: sale.origin ? sale.origin.name : '',
          seller_com: sale.sale_price_ttc * sale.seller_remuneration / 100,
          company_com: sale.sale_price_ttc * (sale.program_remuneration - sale.seller_remuneration) / 100,
          CA: sale.sale_price_ttc * sale.program_remuneration / 100,
          CA_seller: sale.sale_price_ttc * sale.seller_remuneration / 100
        }
      })
    },
    computeRdvsData (rdvs) {
      return rdvs
    },
    computeEntityData (source, keyPath, type, nameGenerator) {
      let entityDict = {}
      for (let item of source) {
        let entityKey = get(item, keyPath)
        if (!entityKey) entityKey = nameGenerator(item)
        if (!(entityKey in entityDict)) {
          entityDict[entityKey] = {
            pk: entityKey,
            type,
            _color: randomcolor({
              seed: item.pk
            }),
            name: nameGenerator(item),
            items: [],
            subEntities: []
          }
        }
        entityDict[entityKey].items.push(item)
      }
      return Object.values(entityDict)
    },
    processSellersDatas (datas) {
      return datas.map(data => {
        let validSales = [...data.items]
        let reserved = data.items.filter(x => x.status === 'reserved')
        let sold = data.items.filter(x => x.status === 'sold')
        let salePriceSum = validSales.reduce((a, sale) => a + sale.sale_price_ttc, 0)
        let sellerProfit = validSales.reduce((a, sale) => a + (sale.sale_price_ttc * (sale.seller_remuneration / 100)), 0)
        let remunerationSum = validSales.reduce((a, sale) => a + sale.seller_remuneration, 0)
        return {
          ...data,
          prereservationsCount: data.items.filter(x => x.status === 'pre_reserved').length,
          reservationsCount: reserved.length,
          actesCount: sold.length,
          cancelCount: data.items.filter(x => x.status === 'canceled').length,
          CA: salePriceSum,
          avgCA: salePriceSum / validSales.length,
          COM: sellerProfit,
          avgCOM: sellerProfit / validSales.length,
          avgRemuneration: remunerationSum / validSales.length
        }
      })
    },
    processTotalSales (sales) {
      const total = sales.reduce((a, b) => {
        return {
          sale_price_ttc: b.sale_price_ttc ? a.sale_price_ttc + b.sale_price_ttc : a.sale_price_ttc + 0,
          seller_com: b.seller_com ? a.seller_com + b.seller_com : a.seller_com + 0,
          company_com: b.company_com ? a.company_com + b.company_com : a.company_com + 0,
          CA: b.CA ? a.CA + b.CA : a.CA + 0,
          CA_seller: b.CA_seller ? a.CA_seller + b.CA_seller : a.CA_seller + 0
        }
      }, { sale_price_ttc: 0, CA: 0, seller_com: 0, company_com: 0, CA_seller: 0 })
      let soldCount = sales.filter(x => x.status === 'sold').length
      let validSales = sales.filter(x => ['sold', 'reserved'].includes(x.status))
      let validSalePrice = validSales.reduce((a, b) => b.sale_price_ttc ? a + b.sale_price_ttc : a + 0, 0)
      return {
        user_name: 'Synthèse',
        program: null,
        lot: null,
        contact: null,
        origin: null,
        sale_count: sales.length,
        prereservation_count: sales.filter(x => x.status === 'pre_reserved').length,
        reservation_count: sales.filter(x => x.status === 'reserved').length,
        sold_count: soldCount,
        canceled_count: sales.filter(x => x.status === 'canceled').length,
        sale_price_ttc: total.sale_price_ttc,
        seller_com: total.seller_com,
        company_com: total.company_com,
        avg_sale_price: total.sale_price_ttc / sales.length,
        avg_valid_sale_price: validSalePrice / validSales.length,
        valid_CA: total.sale_price_ttc,
        CA: total.CA,
        CA_seller: sales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => b.CA_seller ? a + b.CA_seller : a + 0, 0),
        sold_rdv_transfo: this.pastRdvsWithoutR0 > 0 ? soldCount / this.pastRdvsWithoutR0 * 100 : this.pastRdvsWithoutR0,
        chart_valid_CA: sales.filter(x => x.status !== 'canceled').reduce((a, b) => b.sale_price_ttc ? a + b.sale_price_ttc : a + 0, 0)
      }
    },
    openEntity (entity) {
      if (this.statOpenedEntity && this.statOpenedEntity.pk === entity.pk) {
        this.statOpenedEntity = null
      } else {
        this.statOpenedEntity = entity
      }
    }
  }
}
